export default __webpack_public_path__ + "static/media/sylabusFilledIcon.3bcfbb4d.svg";